import React from 'react';
import Hero from '../components/Hero';
import TrustBadges from '../components/TrustBadges';
import UniversShowcase from '../components/UniversShowcase';
import CatalogSection from '../components/CatalogSection';
import Carousel from '../components/Carousel';
import SocialProof from '../components/SocialProof';
import { GuidesHighlight } from '../components/GuidesHighlight';
import Advantages from '../components/Advantages';
import { Sparkles } from 'lucide-react';

// Modification #13 CORRIGÉ: Nouvel ordre des blocs
// 1. Bannière d'annonce (nouveau)
// 2. Hero (contient la barre de recherche remontée)
// 3. Explorez nos univers (UniversShowcase)
// 4. Bandeau noir AVANTAGES (TrustBadges)
// 5. Nos catalogues (CatalogSection)
// 6. Pourquoi choisir 3DLoc (Advantages)
// 7. Matériel populaire (Carousel)
// 8. Avis Google (SocialProof)

// Bannière d'annonce du nouveau site
const AnnouncementBanner = () => (
  <div className="bg-gradient-to-r from-red-600 to-red-500 text-white py-3 px-4">
    <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-center">
      <Sparkles size={18} className="animate-pulse flex-shrink-0" />
      <p className="text-sm sm:text-base font-semibold">
        Bienvenue sur le nouveau site 3D Loc ! Découvrez notre catalogue enrichi et la société Barnum Événement spécialisée dans l'événementiel.
      </p>
      <Sparkles size={18} className="animate-pulse flex-shrink-0" />
    </div>
  </div>
);

const Home = () => {
  return (
    <>
      <AnnouncementBanner />
      <Hero />
      <UniversShowcase />
      <TrustBadges />
      <CatalogSection />
      <Advantages />
      <Carousel />
      <GuidesHighlight />
      <SocialProof />
    </>
  );
};

export default Home;
